<template>
  <div class="row">
    <div class="col-12 col-sm-6 ">
      <label :for="`from${id}`">{{fromLabel}}</label>
      <appDatePicker :key="`${id}FromKey`" v-model="fromDate" :id="`from${id}`" :label="fromLabel"/>
    </div>
    <div class="col-12 col-sm-6 ">
      <label :for="`from${id}`">{{toLabel}}</label>
      <appDatePicker :key="`${id}ToKey`" v-model="toDate" :id="`toCreatedAt${id}`" :toDate="true" :label="toLabel"/>
    </div>
  </div>
</template>
<script>

	import appDatePicker from "./appDatePicker";

	export default {
		components: {appDatePicker},
		props: {
			value: {
				type: Array,
				default: () => []
			},
			name: {
				type: String,
				default: "created_at"
			},
			id: {
				type: String,
			},
      fromLabel: {
				type: String,
        default: 'از تاریخ'
      },
      toLabel: {
				type: String,
        default: 'تا تاریخ'
      }
		},
		data() {
			return {}
		},
		computed: {
			fromDate: {
				get() {
					if (this.value.length) {
						const find = this.value.find(val => val[this.name] && val[this.name].$gte)
						if (find)
							return find[this.name].$gte
					}
					return ""
				},
				set(val) {

					let value = this.value.slice()
					const find = value.find(val => val[this.name] && val[this.name].$gte)
					if (val) {
						if (this.value.length && find) {
							find[this.name].$gte = val
						} else
							value.push({[this.name]: {$gte: val}})
					} else
						value = value.filter((val) => val[this.name] && !val[this.name].$gte)

					this.$emit('input', value)
				},
			},
			toDate: {
				get() {
					if (this.value.length) {
						const find = this.value.find(val => val[this.name] && val[this.name].$lte)
						if (find)
							return find[this.name].$lte
					}
					return ""
				},
				set(val) {
					let value = this.value.slice()
					const find = value.find(val => val[this.name] && val[this.name].$lte)
					if (val) {
						if (this.value.length && find) {
							find[this.name].$lte = val
						} else
							value.push({[this.name]: {$lte: val}})
					} else
						value = value.filter((val) => val[this.name] && !val[this.name].$lte)

					this.$emit('input', value)
				},
			}
		}
	}
</script>

<style lang="scss">

</style>
